import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=f2b98136&scoped=true&"
import script from "./avatar.vue?vue&type=script&lang=js&"
export * from "./avatar.vue?vue&type=script&lang=js&"
import style0 from "./avatar.vue?vue&type=style&index=0&id=f2b98136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b98136",
  null
  
)

export default component.exports